import AbstractException from './abstractException';

export class HttpStatusException extends AbstractException {
  constructor(message, statusCode) {
    super(message);
    this.statusCode = statusCode;
    this.responseData = null;
  }

  setResponseData(responseData) {
    this.responseData = responseData;
  }

  getResponseData() {
    return this.responseData;
  }

  getStatusCode() {
    return this.statusCode;
  }
}

export class BadRequestException extends HttpStatusException {
  constructor(message) {
    super(message, 400);
  }
}

export class UnauthorizedException extends HttpStatusException {
  constructor(message) {
    super(message, 401);
  }
}

export class ForbiddenException extends HttpStatusException {
  constructor(message) {
    super(message, 403);
  }
}

export class NotFoundException extends HttpStatusException {
  constructor(message) {
    super(message, 404);
  }
}

export class ConflictException extends HttpStatusException {
  constructor(message) {
    super(message, 409);
  }
}

export class InternalServerErrorException extends HttpStatusException {
  constructor(message) {
    super(message, 500);
  }
}
export function getHttpException(status) {
  switch (parseInt(status, 10)) {
    case 400:
      return new BadRequestException();
    case 401:
      return new UnauthorizedException();
    case 403:
      return new ForbiddenException();
    case 404:
      return new NotFoundException();
    case 409:
      return new ConflictException();
    case 500:
      return new InternalServerErrorException();
    default:
      return new HttpStatusException();
  }
}
